module.exports = __webpack_public_path__ + "img/thumbnail_SableAntelope_j_normal.b6aac3d6.png";